import { useFeatureFlag } from '@webapp/hooks/useFeatureFlag'
import { selectPrimaryIntegration } from '@webapp/utils/integration/selectPrimaryIntegration'

/**
 * Selects the primary integration to drive sync UI when multiple integrations
 * are active.
 *
 * Gated by feature flag `PLAT_4887_USE_PUSH_INTEGRATION_IF_EXISTS`:
 *   - When ON: prefer the first push-capable integration (Merge, Codat,
 *     legacy NetSuite); fall back to the first integration in the list.
 *   - When OFF: return the first integration in the list, matching the
 *     pre-PLAT-4887 behaviour.
 *
 * Duck-typed on `{ name: string }` so it works for both the raw
 * `Components.Schemas.IntegrationResponse` and the modern `Integration`
 * entity class.
 */
export const useSelectPrimaryIntegration = <T extends { name: string }>(
  integrations: readonly T[]
): T | undefined => {
  const usePushIntegrationIfExists = useFeatureFlag(
    'PLAT_4887_USE_PUSH_INTEGRATION_IF_EXISTS'
  )

  return usePushIntegrationIfExists
    ? selectPrimaryIntegration(integrations)
    : integrations[0]
}
